export function getBaseUrl() {
    return window.ENV_CONFIG.URL_API_INTERNA;
  }

export function getLoginUrl() {
    return window.ENV_CONFIG.URL_LOGIN;
  }

export function getAccessToken() {
    return window.ACCESS_TOKEN_KEY.ACCESS_TOKEN_KEY;
  }

export function getApiBackendUrl() {
    return window.ENV_CONFIG.URL_API_BACKEND;
  }

export function getSsoClientId() {
    return window.ENV_CONFIG.SSO_FLOWBIRD_CLIENT_ID;
  }

export function getSsoKeycloakBase() {
    return window.ENV_CONFIG.SSO_KEYCLOAK_BASE;
  }

export function getSsoRedirectUri() {
    return window.ENV_CONFIG.SSO_REDIRECT_URI;
  }
